/* sb-dc-printcap.js — cap the print file by area, not just by its longest
   side. 2026-09-04.

   sb-dc-aug.js already lowers the dpi on big boards, but the rule it uses only
   looks at the longest side (roughly 12,000 px ÷ longest inch). That keeps a
   long thin banner sane and lets a big square one through: the 8'x8' pop-up
   backdrop comes out 11,960 x 9,464 = 113 megapixels, and a 10' step & repeat
   12,000 x 12,000 = 144. At that size the PNG encode either takes minutes or
   never comes back — the pop-up backdrop add to cart we tested sat at
   cart_add_try with no result for over two minutes.

   So this adds a second limit: total pixels. Where the area rule bites, the
   dpi drops to whatever fits MAX_MP, and the longest-side rule still applies
   on top of it — whichever is lower wins.

   Is 60 MP enough to print? For these sizes, yes. It puts the 8'x8' backdrop
   at about 75 dpi and a 10' step & repeat at about 64 dpi, and both are read
   from several feet away where 60-100 dpi is the trade norm. Small work is
   untouched: anything at or under the cap keeps the dpi it had, so a 2'x4'
   banner still prints at 150.

   MIN_DPI is the floor — below it the file stops being printable at any
   viewing distance, and it is better to let a rare enormous job be slow than
   to send the press something soft.

   Diagnostics: window.__dcPrintCap lists every call it changed. */
(function () {
  'use strict';

  var MAX_MP = 60;     // megapixels in the finished print file
  var MIN_DPI = 60;

  var log = { calls: 0, capped: 0, last: null };
  window.__dcPrintCap = log;

  function install() {
    var orig = window.__dcPrintDpi;
    if (typeof orig !== 'function' || orig.__dcCapped) return false;

    var wrapped = function (spec) {
      var dpi = orig.apply(this, arguments);
      try {
        var s = spec || (window.__dcApi && window.__dcApi.spec) || null;
        var w = s && +s.widthIn, h = s && +s.heightIn;
        if (!w || !h || !dpi) return dpi;

        log.calls++;
        var mp = (w * dpi) * (h * dpi) / 1e6;
        if (mp <= MAX_MP) return dpi;

        /* Area scales with dpi squared, so the dpi that fits the cap is the
           square root of the ratio. */
        var fitted = Math.floor(Math.sqrt((MAX_MP * 1e6) / (w * h)));
        var out = Math.max(MIN_DPI, Math.min(dpi, fitted));
        log.capped++;
        log.last = { w: w, h: h, from: dpi, to: out, mpBefore: Math.round(mp), mpAfter: Math.round(w * out * h * out / 1e6) };
        return out;
      } catch (e) {
        return dpi;   // never block an export over this
      }
    };
    wrapped.__dcCapped = true;
    window.__dcPrintDpi = wrapped;
    return true;
  }

  var tries = 0;
  var t = setInterval(function () {
    if (install() || ++tries > 150) clearInterval(t);
  }, 200);
})();
